// extracted by mini-css-extract-plugin
module.exports = {"Link":"Link_Link__7J1HG","Button":"Link_Button__OTb1y","red":"Link_red__qSQtX"};